import { FacetHierarchy, FacetTerms, FilterHierarchy, FilterTerms, SearchFacet, SearchFilters } from '../model';
import { isFilterHierarchy, isFilterTerms } from './typeGuards';

const findHierarchyTerm = (hierarchyItems: FacetHierarchy['items'], term: string) => {
    for (const item of hierarchyItems) {
        if (item.key === term) {
            return item;
        }
        if (item.children) {
            const childItem = findHierarchyTerm(item.children, term);
            if (childItem) {
                return childItem;
            }
        }
    }

    return null;
};

const filterHierarchyTermsWithResults = (facet: FacetHierarchy, filter: FilterHierarchy): FilterHierarchy => {
    const updatedTerms = filter.terms.filter((term) => {
        const termItem = findHierarchyTerm(facet.items, term);

        return termItem && termItem.count > 0;
    });

    return { ...filter, terms: updatedTerms };
};

const filterTermsWithResults = (facet: FacetTerms, filter: FilterTerms): FilterTerms => {
    return filter.filter((term) => {
        const facetItem = facet.items.find((item) => item.title === term);

        return facetItem && facetItem.count > 0;
    });
};

export const cleanupFiltersWithoutResults = (facets?: SearchFacet[], filters?: SearchFilters) => {
    if (!facets || !filters) {
        return filters;
    }

    return Object.keys(filters).reduce<SearchFilters>((acc, fieldName) => {
        const filter = filters[fieldName];
        const facet = facets.find(({ key }) => key === fieldName);

        if (isFilterHierarchy(filter) && facet?.type === 'hierarchy') {
            return { ...acc, [fieldName]: filterHierarchyTermsWithResults(facet, filter) };
        } else if (isFilterTerms(filter) && facet?.type === 'terms') {
            return { ...acc, [fieldName]: filterTermsWithResults(facet, filter) };
        }

        return { ...acc, [fieldName]: filter };
    }, {});
};
